module.exports = __webpack_public_path__ + "img/maestro_logo.c362b9f2.svg";